<template>
    <PageContainer fullscreen>
        <ScanPanel
            uri="/scan/delivered"
            :title="$t('customer.scan.delivered')"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import ScanPanel from "@/components/elements/ScanPanel.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
</script>

<style scoped>
</style>
